import { render, staticRenderFns } from "./TableListCard.vue?vue&type=template&id=24c01fec&"
import script from "./TableListCard.vue?vue&type=script&lang=js&"
export * from "./TableListCard.vue?vue&type=script&lang=js&"
import style0 from "./TableListCard.vue?vue&type=style&index=0&id=24c01fec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports